import { useEffect, useState } from 'react';
import { getPlanType } from '../planType.helper';


export const usePlanType = () => {
  const [planType, setPlanType] = useState<string | undefined>();

  const setupPlanType = async () => {
    const plan = await getPlanType();
    setPlanType(plan);
  };

  useEffect(() => {
    setupPlanType();
  }, []);

  return {planType};
};